export default __webpack_public_path__ + "static/media/careers_main.f9342ac6.mp4";